import React, { Component } from 'react';
import PropTypes from 'prop-types';
import lodashGet from 'lodash/fp/get';

import extractPhoneFromText from 'common/util/extractPhoneFromText';
import { SR_API_ERROR_ACTION_PAYLOAD_VALIDATION_FAILED } from 'common/errorCodes';

const initialState = {
  formState: {
    phone: '',
  },
};

const isUserNotFoundError = (error) => lodashGet('details.fields.phone', error);
const isPhoneValidationError = (error) => {
  return error && error.name === SR_API_ERROR_ACTION_PAYLOAD_VALIDATION_FAILED;
};
const isUnexpectedError = (error) =>
  error && !isUserNotFoundError(error) && !isPhoneValidationError(error);

class SrLogonasForm extends Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    isSubmitting: PropTypes.bool,
    submitError: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = initialState;
  }

  submitForm = (event) => {
    event.preventDefault();
    const extractedPhone = extractPhoneFromText(this.state.formState.phone);
    this.props.onSubmit({
      phone: extractedPhone,
    });
    this.setState(initialState);
  };

  onInputChange = (event, field) => {
    this.setState({
      formState: {
        ...this.state.formState,
        [field]: event.target.value,
      },
    });
  };

  render() {
    const { isSubmitting, submitError } = this.props;
    const { formState } = this.state;

    return (
      <form onSubmit={this.submitForm}>
        <input
          type="tel"
          pattern="^\(?\+?[\d\(\-\s\)]+$"
          placeholder="5125551234"
          value={formState.phone}
          onChange={(event) => this.onInputChange(event, 'phone')}
        />
        {isPhoneValidationError(submitError) && (
          <div className="formMessage error">
            <span>Sorry, that phone number is not a valid 10-digit phone number</span>
          </div>
        )}
        {isUserNotFoundError(submitError) && (
          <div className="formMessage error">
            <span>Sorry, there is no account with that phone number</span>
          </div>
        )}
        <button type="submit" className="button yellow" disabled={isSubmitting || !formState.phone}>
          {isSubmitting ? 'logging in as...' : 'login as user'}
        </button>
        {isUnexpectedError(submitError) && (
          <div className="formMessage error">{submitError.message}</div>
        )}
      </form>
    );
  }
}

SrLogonasForm.displayName = 'SrLogonasForm';

export default SrLogonasForm;
